<template>
    <select
        class="form-control simple-select"
        :class="inputClasses"
        data-toggle="tooltip-city"
        :id="id"
        :name="name"
        :title="title"
        :disabled="disabled"
        :required="required"
        :multiple="multiple"
        v-model="valueCopy"

        @focus="handleFocus(true)"
        @blur="handleFocus(false)"
        @input="handleModelInput"
    >
        <option v-for="(option, index) in optionsList" :value="reduceItem(option)" :key="`${id}-${index}`">
            {{ label in option ? option[label] : option }}
        </option>
    </select>
</template>

  <script>
    export default {
        name: 'SimpleSelect',
        props: {
            id: {
                type: String,
                default: null
            },
            name: {
                type: String,
                default: null
            },
            value: {
                default: null
            },
            title: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: "label"
            },
            disabled: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                default() {
                    return [];
                }
            },
            reduceObject: {
                type: Boolean,
                default: false
            },
            reduce: {
                type: Function,
                default: option => option.id,
            },
            autocomplete: {
                type: String,
                default: 'off',
            },
            inputClasses: {
                type: [Array, Object, String],
                default: null
            },
        },
        data () {
            return {
                valueCopy: null,
                focus: false,
                valid: true
            }
        },
        beforeMount () {
            // Here we are following the Vue2 convention on custom v-model:
            // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
            this.copyValue(this.value)
        },
        computed: {
            computedClasses () {
                return {
                    'material--active': this.focus,
                    'material--disabled': this.disabled,
                    'material--has-errors': Boolean(!this.valid),
                    'material--raised': Boolean(
                        this.focus ||
                        this.hasValue || // has value
                        (this.placeholder && !this.hasValue)), // has placeholder
                }
            },
            activeClass () {
                return {
                    'active': Boolean(
                        this.focus ||
                            this.hasValue || // has value
                            (this.placeholder && !this.hasValue)) // has placeholder
                }
            },
            hasValue () {
                return this.multiple ? this.valueCopy!=null && this.valueCopy.length>0 : !this.idNull;
            },
            idNull() {
                return this.valueCopy === undefined || this.valueCopy === null;
            },
            optionsList() {
                return this.options;
            },
            reduceItem() {
                if(this.reduceObject){
                    return option => option;
                }
                return this.reduce;
            },
        },
        watch: {
            value (newValue) {
                // This watch works from the code side of the 2-way-binding:
                this.copyValue(newValue)
            }
        },
        methods: {
            handleModelInput(event) {
                this.$emit('input', event.target.value, event)
            },
            handleFocus(focused) {
                if(!this.disabled){
                    this.focus = focused
                }
            },
            copyValue (value) {
                this.valueCopy = value
            },
        }
    }
  </script>